//= ========================================================================
import { servicesConfigurations } from './ServicesConfigurations';

const theme = 'theme';
const services = 'services';
const launch = 'launch';
const deliverables = 'deliverables';
const onboarding = 'onboarding';
const keyboard = 'keyboard';
const send = 'send';
const development = 'development';

export const getJSONConfig = () => mainConfigurations();
export const getDefaultGlobJSON = () => mainConfigurations();

const mainConfigurations = () => ({
  version: 16,
  bank_name: 'PayKey',
  user_name: 'demo',
  full_name: 'Full Demo',
  last_updated_at: 'Not saved yet',
  updated_by: '',
  last_published_at: 'Never published',
  published_by: '',
  last_sdk_created_at: 'Never created',
  sdk_created_by: '',
  firebase_version_path: '',
  web_tool_version: 0,
  firebase_version: 0,
  configurations: {
    screens_ordering: [
      theme,
      services,
      launch,
      deliverables,
      onboarding,
      keyboard,
      send,
      development,
    ],
    screens_ordering_slideshow: [
      'onboarding',
      'launch',
      'services',
      'theme',
      'send',
    ],
    theme: {
      screens_ordering: [
        'colors',
        'radius',
        'fonts',
      ],
      colors: {
        avatar_color_1: '#006DC7',
        avatar_color_2: '#008CFF',
        avatar_color_3: '#48BB78',
        avatar_color_4: '#667EEA',
        primary_font_color: '#001A2f',
        secondary_font_color: '#718096',
        tertiary_icons_color: '#A0AEC0',
        cta_font_color: '#FFFFFF',
        links_icons_color: '#008CFF',
        menu_primary_color: '#001A2F',
        menu_secondary_color: '#718096',
        primary_cta_color: '#008CFF',
        disabled_cta_color: '#99D1FF',
        pressed_cta_color: '#006DC7',
        border_color: '#CBD5E0',
        border_light_color: '#E2E8F0',
        light_elements_color: '#F7FAFC',
        menu_top_area_color: '#F7FAFC',
        menu_balance_color: '#EDF2F7',
        app_background_color: '#FFFFFF',
        positive_color: '#48BB78',
        negative_color: '#F56565',
      },
      radius: {
        elements_shape_square: true,
      },
      fonts: {
        use_custom_android_font_in_keyboard: true,
        use_custom_font_in_onboarding_screens: true,
        custom_font: {
          fName: null,
          fUri: null,
          fID: null,
        },
        custom_bold_font: {
          fName: null,
          fUri: null,
          fID: null,
        },
      },
    },
    services: servicesConfigurations(),
    launch: {
      screens_ordering: [
        'keyboard',
        'auth',
        'error_messages',
        'empty_state',
        'expand_message',
      ],
      keyboard: {
        no_results_image: {
          fName: null,
          fUri: null,
          fID: null,
        },
        bank_logo: {
          fName: null,
          fUri: null,
          fID: null,
        },
        access_to_bank_info_message: true,
        l_k_title: 'Welcome to the [bank] keyboard!',
        l_k_message: 'Now you can easily perform banking actions directly from the keyboard and share them in your social conversations.',
        l_k_cancel: 'Cancel',
        got_it: 'Understood',
      },
      auth: {
        auth_upon_tapping_the_bank_icon: false,
        auth_upon_transactions: false,
        face_id_to_approve: 'Face ID to continue',
        touch_id_to_approve: 'Touch ID to continue',
        enter_your_pin_code: 'Enter PIN code to continue',
        enter_the_code_you_just_received: 'My code is',
        enter_credentials: 'Enter credentials',
        username: 'Username',
        password: 'Password',
        approve: 'Approve',
        change_id: 'Change ID',
        auth_password_error: 'Password is incorrect, please try again',
        auth_pin_code_error: 'Wrong PIN, please try again',
        auth_wrong_code_error: 'Wrong code, please try again',
      },
      error_messages: {
        general_error_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        no_connection_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        transaction_failed_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        permission_to_photos_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        no_landscape_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        error_message_general_error: 'Sorry, something went wrong…',
        error_message_no_connection: 'Whoops![BR]Internet connection is lost…',
        error_message_transaction_failed: 'Transaction was incomplete',
        error_message_permission_to_photos: 'Let “Bank app” access to your photos',
        error_message_landscape_not_supported: 'This service only works in portrait. Rotate your device to continue.',
        try_again: 'Try again',
        take_me_to_settings: 'Take me to Settings',
        reload: 'Reload',
      },
      empty_state: {
        empty_state_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        nothing_to_see_here: 'Nothing to see here…',
        your_bills: 'Your bills',
      },
      expand_message: {
        imsg_expand_title: 'Expand to use [bank] on iMessage',
        imsg_expand_button: 'Open Services',
      },
    },
    deliverables: {
      screens_ordering: [
        'deliverables',
        'user_types',
      ],
      deliverables: {
        iMsg_enabled: false,
        redirect_from_keyboard_enabled: false,
      },
      user_types: {
        userTypes: [{
          typeID: 0,
          description: 'Default',
          services: [],
        }],
      },
    },
    onboarding: {
      screens_ordering: [
        'announcement',
        'promotion',
        'instructions',
      ],
      announcement: {
        kbd_announcement_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        enable_keyboard_activation_flow: true,
        enable_keyboard_privacy_link: true,
        privacy_policy_link: 'Enter the URL here',
        o_a_title: 'Enjoy instant & secure access to banking services straight from your keyboard',
        o_a_button_title: 'Get [bank]’s keyboard now',
        o_a_privacy_policy: 'Terms & Privacy Policy',
        maybe_later: 'Maybe later',
      },
      promotion: {
        menu_screenshot: {
          fName: null,
          fUri: null,
          fID: null,
        },
        onboarding_big_stickers: {
          fName: null,
          fUri: null,
          fID: null,
        },
        onboarding_small_stickers: {
          fName: null,
          fUri: null,
          fID: null,
        },
        onboarding_screen_2_is_automatic: true,
        onboarding_screen_3_is_security: true,
        promo_text_1: 'The best typing experience together with your bank –[BR]all in one',
        promo_text_2: 'Instantly send money with just a few taps in the keyboard',
        promo_text_3: 'Personalize your typing with GIFs, emojis & more',
        promo_text_4: 'Protected by [bank]’s privacy & security anytime, anywhere',
        o_a_button_title: 'Get [bank]’s keyboard now',
        maybe_later: 'Maybe later',
      },
      instructions: {
        kbd_come_back_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        kbd_success_icon: {
          fName: null,
          fUri: null,
          fID: null,
        },
        enable_keyboard_with_string: true,
        o_i_step_1_of_2: 'Step 1 of 2',
        o_i_enable_bank_keyboard: 'Enable [bank] keyboard',
        o_i_enable_bank_keyboard_and: 'Enable [bank]’s keyboard in the phone’s settings',
        o_i_goto_settings: 'Go to settings > [bank]',
        o_i_tap_keyboards: 'Tap Keyboards',
        o_i_enable_keyboard: 'Enable Keyboard & Allow full access*',
        o_i_come_back_here: 'Come back here once done',
        o_i_your_privacy_title: 'We respect your privacy',
        o_i_your_privacy: 'The keyboard will never collect personal typing data such as passwords, credit card numbers, etc.',
        o_i_take_me_there: 'Take me there',
        o_i_nanother_time: 'Do it another time',
        maybe_later: 'Maybe later',
        o_i_step_2_of_2: 'Step 2 of 2',
        o_i_switch_to_bank_keyboard: 'Switch to [bank] keyboard',
        o_i_switch_to_bank_keyboard_and: 'Set [bank]’s keyboard as your default input',
        o_i_lets_do_it: "Let's do it",
        o_i_touch_and_hold: 'Touch and hold [globe] or [emoji] and select [bank] keyboard.',
        success: 'Success!',
        o_done: 'Done',
        o_i_give_it_a_go: 'Give it a go',
        o_i_tap_the_bank_icon: 'Tap the bank icon to access your account, send money and more.',
        bank_keyboard: "[bank]'s keyboard",
        keyboard_button: 'Space',
        onboarding_titleBar: 'Keyboards',
        another_keyboard: 'Another keyboard',
        select_keyboard: 'Select keyboard',
        other_keyboards: 'English (US)',
      },
    },
    keyboard: {
      screens_ordering: [
        'keyboard_language',
        'promotion',
      ],
      keyboard_language: {
        is_rebit_engine: true,
        is_OTA_dictionary_installed: true,
        default_languages: { rebit_engine: 'en_us', paykey_engine: 'en_us' },
        available_languages: {
          paykey_engine: {
            id: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            en_in: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            en_gb: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            en_us: { available: true, can_be_default: true, enabled_upon_keyboard_launch: true },
            fr: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            de: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            iw: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            ja: { available: false, can_be_default: false, enabled_upon_keyboard_launch: false },
            kk_kz: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            ko: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            pl: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            ro: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            sk: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            zh_hk: { available: false, can_be_default: false, enabled_upon_keyboard_launch: false },
            zh_tw: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            es_419: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
          },
          rebit_engine: {
            en_us: { available: true, can_be_default: true, enabled_upon_keyboard_launch: true },
            iw: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            ko: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            pt_br: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            zh_tw: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            de_at: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            kk: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            pt: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            ru: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            km: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
            es_us: { available: false, can_be_default: true, enabled_upon_keyboard_launch: false },
          },
        },
      },
      promotion: {
        enable_promotion: false,
        empty_state_image: {
          fName: null,
          fUri: null,
          fID: null,
        },
      },
    },
    send: {
      screens_ordering: [
        'form',
      ],
    },
    general: {
      success_image: {
        fName: null,
        fUri: null,
        fID: null,
      },
      verify_recipient_icon: {
        fName: null,
        fUri: null,
        fID: null,
      },
      img_arrow_right_button: {
        fName: null,
        fUri: null,
        fID: null,
      },
      show_avatar_in_contact_lists: true,
      is_arrow_icon: true,
      send_screen_checklist_completed: true,
      bank_name: 'PayKey',
    },
  },
  screensList: [
    {
      screen_name: 'theme_colors',
      category: 'theme',
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'theme_radius',
      category: 'theme',
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'theme_fonts',
      category: 'theme',
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'services',
      category: 'services',
      sub_category: 'menu',
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'send_money_recipients_list',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'menu',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_search_results',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'search_results',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_transfer_method',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'transfer_method',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_to_credit_card_manually',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'credit_card',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_to_phone_manually',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'phone_number',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_to_account_manually',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'bank_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_to_iban_manually',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'iban',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_to_customer_id_manually',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'customer_id',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_to_cpf_cnpj_manually',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'cpf_cnpj',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_to_email_manually',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'email',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_to_evp_manually',
      category: 'services',
      sub_category: 'send_money',
      step: 'recipient',
      recipient_step: 'evp',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'send_money_enter_amount',
      category: 'services',
      sub_category: 'send_money',
      step: 'amount',
      amount_step: 'enter_amount',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'send_money_change_paying_account',
      category: 'services',
      sub_category: 'send_money',
      step: 'amount',
      amount_step: 'change_paying_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'send_money_reference',
      category: 'services',
      sub_category: 'send_money',
      step: 'reference',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'send_money_confirmation',
      category: 'services',
      sub_category: 'send_money',
      step: 'confirmation',
      duplication_number: 0,
      screen_index: 0,
      step_index: 3,
    },
    {
      screen_name: 'send_money_success',
      category: 'services',
      sub_category: 'send_money',
      step: 'success',
      duplication_number: 0,
      screen_index: 0,
      step_index: 4,
    },
    {
      screen_name: 'loan_amount',
      category: 'services',
      sub_category: 'loan',
      step: 'amount',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'loan_installments_number',
      category: 'services',
      sub_category: 'loan',
      step: 'number',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'loan_source',
      category: 'services',
      sub_category: 'loan',
      step: 'source',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'loan_installments_option',
      category: 'services',
      sub_category: 'loan',
      step: 'option',
      duplication_number: 0,
      screen_index: 0,
      step_index: 3,
    },
    {
      screen_name: 'loan_confirmation',
      category: 'services',
      sub_category: 'loan',
      step: 'confirmation',
      duplication_number: 0,
      screen_index: 0,
      step_index: 4,
    },
    {
      screen_name: 'loan_success',
      category: 'services',
      sub_category: 'loan',
      step: 'success',
      duplication_number: 0,
      screen_index: 0,
      step_index: 5,
    },
    {
      screen_name: 'account_info_balance',
      category: 'services',
      sub_category: 'account_info',
      step: 'balance',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'account_info_inout',
      category: 'services',
      sub_category: 'account_info',
      step: 'transactions',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'pay_bills_bills_list',
      category: 'services',
      sub_category: 'pay_bills',
      step: 'select_bill',
      amount_step: 'enter_amount',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'pay_bills_Change_paying_account',
      category: 'services',
      sub_category: 'pay_bills',
      step: 'select_bill',
      amount_step: 'change_paying_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'pay_bills_choose_method',
      category: 'services',
      sub_category: 'pay_bills',
      step: 'select_bill',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'pay_bills_enter_code',
      category: 'services',
      sub_category: 'pay_bills',
      step: 'select_bill',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'pay_bills_confirmation',
      category: 'services',
      sub_category: 'pay_bills',
      step: 'confirmation_bill',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'pay_bills_success',
      category: 'services',
      sub_category: 'pay_bills',
      step: 'success',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_reference',
      category: 'services',
      sub_category: 'request_payment',
      step: 'reference',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'request_payment_enter_amount',
      category: 'services',
      sub_category: 'request_payment',
      step: 'amount',
      amount_step: 'enter_amount',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'request_payment_change_paying_account',
      category: 'services',
      sub_category: 'request_payment',
      step: 'amount',
      amount_step: 'change_paying_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'request_payment_recipients_list',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'menu',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_search_results',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'search_results',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_transfer_method',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'transfer_method',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_to_credit_card_manually',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'credit_card',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_to_phone_manually',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'phone_number',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_to_account_manually',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'bank_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_to_iban_manually',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'iban',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_to_customer_id_manually',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'customer_id',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_to_cpf_cnpj_manually',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'cpf_cnpj',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_to_email_manually',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'email',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_to_evp_manually',
      category: 'services',
      sub_category: 'request_payment',
      step: 'recipient',
      recipient_step: 'evp',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'request_payment_confirmation',
      category: 'services',
      sub_category: 'request_payment',
      step: 'confirmation',
      duplication_number: 0,
      screen_index: 0,
      step_index: 3,
    },
    {
      screen_name: 'request_payment_success',
      category: 'services',
      sub_category: 'request_payment',
      step: 'success',
      duplication_number: 0,
      screen_index: 0,
      step_index: 4,
    },
    {
      screen_name: 'split_payment_reference',
      category: 'services',
      sub_category: 'split_payment',
      step: 'reference',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'split_payment_enter_amount',
      category: 'services',
      sub_category: 'split_payment',
      step: 'amount',
      amount_step: 'enter_amount',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,

    },
    {
      screen_name: 'split_payment_change_paying_account',
      category: 'services',
      sub_category: 'split_payment',
      step: 'amount',
      amount_step: 'change_paying_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'split_payment_recipients_list',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'menu',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_search_results',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'search_results',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_transfer_method',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'transfer_method',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_to_credit_card_manually',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'credit_card',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_to_phone_manually',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'phone_number',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_to_account_manually',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'bank_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_to_iban_manually',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'iban',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_to_customer_id_manually',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'customer_id',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_to_cpf_cnpj_manually',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'cpf_cnpj',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_to_email_manually',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'email',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_to_evp_manually',
      category: 'services',
      sub_category: 'split_payment',
      step: 'recipient',
      recipient_step: 'evp',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_confirm_participant',
      category: 'services',
      sub_category: 'split_payment',
      step: 'confirmation_split',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'split_payment_confirmation',
      category: 'services',
      sub_category: 'split_payment',
      step: 'confirmation_split',
      duplication_number: 0,
      screen_index: 0,
      step_index: 3,
    },
    {
      screen_name: 'split_payment_success',
      category: 'services',
      sub_category: 'split_payment',
      step: 'success',
      duplication_number: 0,
      screen_index: 0,
      step_index: 4,
    },
    {
      screen_name: 'top_up_recipients_list',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'menu',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_search_results',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'search_results',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_transfer_method',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'transfer_method',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_to_credit_card_manually',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'credit_card',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_to_phone_manually',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'phone_number',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_to_account_manually',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'bank_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_to_iban_manually',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'iban',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_to_customer_id_manually',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'customer_id',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_to_cpf_cnpj_manually',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'cpf_cnpj',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_to_email_manually',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'email',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_to_evp_manually',
      category: 'services',
      sub_category: 'top_up',
      step: 'recipient',
      recipient_step: 'evp',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'top_up_select_operator',
      category: 'services',
      sub_category: 'top_up',
      step: 'operator',
      duplication_number: 0,
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'top_up_select_package',
      category: 'services',
      sub_category: 'top_up',
      step: 'amount_package',
      amount_step: 'enter_amount',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'top_up_change_paying_account',
      category: 'services',
      sub_category: 'top_up',
      step: 'amount_package',
      amount_step: 'change_paying_account',
      duplication_number: 0,
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'top_up_reference',
      category: 'services',
      sub_category: 'top_up',
      step: 'reference',
      duplication_number: 0,
      screen_index: 0,
      step_index: 3,
    },
    {
      screen_name: 'top_up_confirmation',
      category: 'services',
      sub_category: 'top_up',
      step: 'confirmation',
      duplication_number: 0,
      screen_index: 0,
      step_index: 4,
    },
    {
      screen_name: 'top_up_success',
      category: 'services',
      sub_category: 'top_up',
      step: 'success',
      duplication_number: 0,
      screen_index: 0,
      step_index: 5,
    },
    {
      screen_name: 'link_out',
      category: 'services',
      sub_category: 'link_out',
      step: 'link_out',
      duplication_number: 0,
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'launch_keyboard',
      category: 'launch',
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'launch_auth',
      category: 'launch',
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'launch_error_messages',
      category: 'launch',
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'launch_empty_state',
      category: 'launch',
      screen_index: 0,
      step_index: 3,
    },
    {
      screen_name: 'imsg_expand_texts',
      category: 'launch',
      screen_index: 0,
      step_index: 4,
    },
    {
      screen_name: 'deliverables',
      category: 'deliverables',
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'user_types',
      category: 'deliverables',
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'onboarding_announcement',
      category: 'onboarding',
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'onboarding_promotion',
      category: 'onboarding',
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'onboarding_instructions',
      category: 'onboarding',
      screen_index: 0,
      step_index: 2,
    },
    {
      screen_name: 'keyboard_language',
      category: 'keyboard',
      screen_index: 0,
      step_index: 0,
    },
    {
      screen_name: 'promotion',
      category: 'keyboard',
      screen_index: 0,
      step_index: 1,
    },
    {
      screen_name: 'send_form',
      category: 'send',
    },
    {
      screen_name: 'development_configurations',
      category: 'development',
    },
  ],
});
